<template>
  <div class="mx-auto w-full max-w-md px-6 pt-6 pb-6">
    <div v-if="hasImages" class="relative mx-5 pt-20">
      <div
        :key="`image-${feedbackValue}`"
        class="absolute top-2 flex h-16 -translate-x-1/2 flex-row items-center justify-around bg-cover"
        :style="{
          left: imgPosistion,
        }"
      >
        <div
          v-if="currentScaleItemIndex <= Math.floor(scale.numberOfSteps / 2)"
          class="top-2 aspect-square bg-cover"
          :style="{
            height: leftImageHeight,
            'background-image': `url('${scale.left.image}')`,
          }"
        ></div>
        <div
          v-if="currentScaleItemIndex >= Math.floor(scale.numberOfSteps / 2)"
          class="top-2 aspect-square bg-cover"
          :style="{
            height: rightImageHeight,
            'background-image': `url('${scale.right.image}')`,
          }"
        ></div>
      </div>
    </div>

    <input
      v-model.number="feedbackValue"
      type="range"
      :min="0"
      :max="1"
      :step="scale.items[1].value"
      class="slider bg-auraheilerin-80 my-6 h-1 w-full cursor-pointer appearance-none rounded-full md:h-2"
    />
    <div class="text-label-large flex w-full flex-row justify-between">
      <span class="max-w-40">{{ scale.left.label }}</span>
      <span class="max-w-40 text-right">{{ scale.right.label }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import { scaleMiddleElementValue, type BipolarScale } from '../../../../core/models/scale'

  interface Props {
    scale: BipolarScale
    identifier: string
    disabled?: boolean
    value?: number
  }

  const props = defineProps<Props>()

  const feedbackValue = defineModel<number>()

  onMounted(() => {
    if (!feedbackValue.value) {
      feedbackValue.value = scaleMiddleElementValue(props.scale)
    }
  })

  const hasImages = computed(() => props.scale.left.image && props.scale.right.image)

  const currentScaleItemIndex = computed(() =>
    props.scale.items.findIndex((i) => i.value == feedbackValue.value),
  )

  const imgPosistion = computed(() => (feedbackValue.value ?? 0) * 100 + '%')

  const leftImageHeight = computed(
    () =>
      (100 / (props.scale.numberOfSteps - 1)) *
        (props.scale.numberOfSteps - currentScaleItemIndex.value - 1) +
      '%',
  )

  const rightImageHeight = computed(
    () => (100 / (props.scale.numberOfSteps - 1)) * currentScaleItemIndex.value + '%',
  )
</script>
